import React, { FC, memo } from 'react'
import Link from 'next/link'
import { ConditionalWrapper } from '@ucheba/utils/helpers/components'
import SC from '../base/Pagination.styles'
import { IPaginationProps } from '../types'
import { Button } from '../../Button/desktop'
import { ButtonGroup } from '../../ButtonGroup/desktop'
import TriangleArrowLeftIcon from '../../../icons/icon__triangle-arrow_left.svg'
import TriangleArrowRightIcon from '../../../icons/icon__triangle-arrow_right.svg'
import { usePaginationCore } from '../bll'

const { Block } = SC

/** Пагинация */
const Pagination: FC<IPaginationProps> = (props) => {
  const { currentPage, totalPages, getHrefWithPage, shallow = false } = props

  const { hrefAsWithPage, itemsPagination, changeCurrentPage } = usePaginationCore(props)

  return (
    <Block>
      <ButtonGroup spacing='small'>
        <ConditionalWrapper
          condition={currentPage !== 1}
          wrapper={(children): JSX.Element => (
            <Link
              shallow={shallow}
              href={
                getHrefWithPage
                  ? getHrefWithPage(currentPage - 1)
                  : hrefAsWithPage(currentPage - 1)
              }
              passHref
            >
              {children}
            </Link>
          )}
        >
          <Button
            color='blue'
            icon
            size='small'
            onClick={changeCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}
            title='Предыдущая страница'
          >
            <TriangleArrowLeftIcon />
          </Button>
        </ConditionalWrapper>

        {itemsPagination}

        <ConditionalWrapper
          condition={currentPage !== totalPages}
          wrapper={(children): JSX.Element => (
            <Link
              href={
                getHrefWithPage
                  ? getHrefWithPage(currentPage + 1)
                  : hrefAsWithPage(currentPage + 1)
              }
              passHref
            >
              {children}
            </Link>
          )}
        >
          <Button
            color='blue'
            icon
            size='small'
            onClick={changeCurrentPage(currentPage + 1)}
            disabled={currentPage === totalPages}
            title='Следующая страница'
          >
            <TriangleArrowRightIcon />
          </Button>
        </ConditionalWrapper>
      </ButtonGroup>
    </Block>
  )
}

export { Pagination }
export default memo(Pagination)
